import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import avatar from '../assets/avatar.png'
import { logout } from '../services/authService';
import { clearSessionPreservingConfigs } from '../utils/sessionStorage';


export const MenuComponent = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // Obtener el nombre del usuario del sessionStorage
    const getUserName = () => {
        const userInfo = sessionStorage.getItem('userinfo');
        if (userInfo) {
            const parsedUserInfo = JSON.parse(userInfo);
            return parsedUserInfo.name;
        }
        return 'Usuario'; // Nombre predeterminado si no se encuentra el valor
    };

    const deleteAllCookies = () => {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }
    };
    const handleLogout = async () => {
        try {
            // Obtener el token del sessionStorage (ajusta la clave según cómo lo guardes)
            const token = sessionStorage.getItem('access_token');
            if (!token) {
                throw new Error('No se encontró el token de autenticación.');
            }

            // Llamar al método logout y obtener la URL de redirección si está disponible
            const redirectUrl = await logout(token);

            // Limpiar la información de sesión
            deleteAllCookies();
            clearSessionPreservingConfigs();

            if (redirectUrl) {
                window.location.href = redirectUrl;
            } else {
                navigate('/');
            }
        } catch (error) {
            clearSessionPreservingConfigs();
            deleteAllCookies();
            navigate('/');
        }
    };

    const handleBackToHome = () => {
        // Redirigir a la página de inicio
        const baseURL = window.location.hostname;
        navigate(baseURL.includes(process.env.REACT_APP_VALIDATOR_BASE_URL) ? '/validator' : '/');
    };
    return (
        <div className="nav-dropdown">
            <button type="button" className="dropdown-item btn-medium btn-secondary">
                <img src={avatar} alt="Icono avatar" className="img-fluid" />
                <span> {getUserName()} </span>
            </button>
            <div className="dropdown-content">
                <button type="button" className="dropdown-content__item" onClick={handleLogout}> {t('navbar.cerrar-sesion')} </button>
            </div>
        </div>
    );
};

export default MenuComponent;
